var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYear({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_year",
    "data-name": "icon year",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Update",
    d: "M10.172,2.206a.749.749,0,0,0-1.032,0,.685.685,0,0,0,0,.994l1.3,1.255-.28,0c-.183,0-.354.006-.478.009l-.149,0H9.489A6.385,6.385,0,0,0,3,10.736,6.385,6.385,0,0,0,9.5,17,6.385,6.385,0,0,0,16,10.736a.73.73,0,0,0-1.459,0A4.952,4.952,0,0,1,9.5,15.594a4.952,4.952,0,0,1-5.041-4.858A4.952,4.952,0,0,1,9.5,5.878h.075l.144,0,.462-.009c.221,0,.437,0,.6,0L9.14,7.449a.685.685,0,0,0,0,.994.749.749,0,0,0,1.032,0l2.72-2.622a.685.685,0,0,0,0-.994Z",
    transform: "translate(-3 -2)",
    fill: "#d6d6d6",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYear);
export default __webpack_public_path__ + "static/media/year.cce62fea04d756e909e54bfd03c6c2f9.svg";
export { ForwardRef as ReactComponent };